import type { Activity } from "@/types";

/** Response body may omit fields the client normalizes. */
export type ActivityApiPayload = Omit<Activity, "booking_cutoff_minutes"> & {
  booking_cutoff_minutes?: number;
};

const DEFAULT_BOOKING_CUTOFF_MINUTES = 0;

function normalizeBookingCutoffMinutes(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value)
    ? value
    : DEFAULT_BOOKING_CUTOFF_MINUTES;
}

export function activityFromApi(activity: ActivityApiPayload): Activity {
  return {
    ...activity,
    booking_cutoff_minutes: normalizeBookingCutoffMinutes(
      activity.booking_cutoff_minutes,
    ),
  };
}

export function activitiesFromApi(
  activities: ActivityApiPayload[],
): Activity[] {
  return activities.map(activityFromApi);
}
